import React from "react";
import "./order-cards.scss";

// Keep the desktop cells and their handlers as the single source of truth.
export function SupplierOrderCollection({ mobile, children, ...props }: any) {
  if (!mobile) return <table {...props}>{children}</table>;
  const body = React.Children.toArray(children).find((child: any) => child.type === "tbody") as React.ReactElement<any>;
  return <div className="supplier-order-cards">{body?.props.children}</div>;
}

export function SupplierOrderCard({ mobile, children, order, siteLabel, ...props }: any) {
  if (!mobile) return <tr {...props}>{children}</tr>;
  const cells = React.Children.toArray(children) as React.ReactElement<any>[];
  const site = order?.site || order?.supplier_site?.name;
  return <article className="supplier-order-card" data-order-id={order?.id}>
    <header className="supplier-order-card__actions">{cells[0]?.props.children}</header>
    <dl>
      {cells.slice(1).map((cell, index) => <div key={index}>
        <dt>{cell.props["data-label"]}</dt>
        <dd>{cell.props.children}</dd>
      </div>)}
      {typeof site === "string" && site && <div><dt>{siteLabel}</dt><dd>{site}</dd></div>}
    </dl>
  </article>;
}
